import React, { useEffect } from "react";

export default function SingleRow({
  columnLabels,
  selectedRow,
  rowData,
  rowIndex,
  updateFunc,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  const UpdateRowDataByRowIndex = (value) => {
    const updatedRowData = [...rowData];
    updatedRowData[rowIndex] = value;
    updateFunc((prev) => updatedRowData);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    UpdateRowDataByRowIndex({
      ...selectedRow,
      rowValues: {
        ...selectedRow.rowValues,
        hideHeader: selectedRow?.rowValues?.hideHeader === false ? false : true,
      },
    });
  }, []);

  return (
    <div className="row mb-2">
      <div className="col-md-3 px-1 mx-0 d-flex align-items-center">
        <input
          type="checkbox"
          name="hideHeader"
          className=" h-50 w-50 "
          checked={selectedRow.rowValues.hideHeader || false}
          onChange={(e) => {
            const isChecked = e.target.checked;
            UpdateRowDataByRowIndex({
              ...selectedRow,
              rowValues: { ...selectedRow.rowValues, hideHeader: isChecked },
            });
          }}
        />
        <label className="text-nowrap">Hide Header</label>
      </div>
      <div className="col-md-4 px-1 mx-0">
        <input
          type="text"
          name="customHeader"
          placeholder="Custom Header"
          className="form-control form-control-sm"
          value={selectedRow?.rowValues?.customHeader || ""}
          onChange={(e) => {
            const newValue = e.target.value;
            UpdateRowDataByRowIndex({
              ...selectedRow,
              rowValues: { ...selectedRow?.rowValues, customHeader: newValue },
            });
          }}
        />
      </div>
      <div className="col-md-5 px-1 mx-0">
        <select
          name="columns"
          className="form-control form-control-sm"
          value={selectedRow?.rowValues?.column || ""}
          onChange={(e) => {
            const selectedColumn = e.target.value;
            UpdateRowDataByRowIndex({
              ...selectedRow,
              rowValues: { ...selectedRow.rowValues, column: selectedColumn },
            });
          }}
        >
          <option value="">Select Column</option>
          {columnLabels?.map((label, index) => (
            <option key={index} value={label}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
